<template>
    <div class="homeheader">
        <div class="header" >
            <div class="containers">
                <div class="top" :class="{'topbar-scroll-bg': leaveTop}">
                    <div class="container top" v-show='showHeader'>
                        <a @click="KEWLSensorTrack('首页')" :href="getHeaderLink('/')"  class="logo"></a>
                        <a v-if="isJmt" href="https://babyou.nownews.com/" target="_blank" class="logo-jmt"></a>
                        <div class="action">
                            <div class="right-header menu" @click="changeMenu(false)"></div>
                               <div v-if="islogined" class="login_info right-header" >
                                <span class="face" @mouseenter="showLogout()" @mouseleave="hideLogout()"  :style="userFace"></span>
                                <a class="nickname" @mouseenter="showLogout()" @mouseleave="hideLogout()">{{userInfo&&userInfo.nickname}}</a>
                                <div class="logout" @mouseenter="showLogout()" @mouseleave="hideLogout()" :class="{none: logoutDisplay}" @click="logoutAction();">{{ $t("logOut") }}</div>
                            </div>
                            <div class="logwrap right-header" v-else>
                                <a href="javascript:;" class="login logwrap_login" @click="doLogin();">{{ `${$t("signIn")} / ${$t('userSign.signUp')}` }}</a>
                            </div>
                            <a class="recharge_wrap right-header" v-if="islogined">
                                <span class="recharge_txt">{{ $t("wallet") }}</span>
                                <div class="recharge_list">
                                    <a class="convert" @click="doConvert();" href="javascript:;">{{ $t("convertToCoins") }}</a>
                                    <a class="cash" @click="doCashOut();" href="javascript:;">{{ $t("cashOut") }}</a>
                                </div>
                            </a>
                            <a class="right-header" @click="doRecharge();" href="javascript:;">
                                <span class="recharge_txt">{{ $t("recharge") }}</span>
                            </a>
                            <a @click="KEWLSensorTrack('/explore.html')" :href="getHeaderLink('/explore.html')" class="right-header explore" :class="getCurrentStatus == 'explore' ? 'current' : ''">{{ $t("explorePage") }}</a>
                        </div>
                    </div>
                </div>
                <div class="top toprelative"></div>
                <right-menu :closeState="closeState" :changeMenu="changeMenu"></right-menu>
                <loginReg
                    ref="logReg"
                    :success="successHandle"
                    :logout="logoutHandle"
                    ></loginReg>
            </div>
        </div>
    </div>
</template>
<script>

import webRecharge from '@utils/webrecharge';
import webConvertAndCash from '@utils/webConvertAndCash';
import util from '@utils/util';
import webLogin from '@utils/weblogin';
import loginReg from '../../login-reg/src/wrap';
import rightMenu from './rightmenu';

export default {
    name: 'globalHeader',
    data() {
        return {
            isJmt: false, // 姐妹淘
            userInfo: null,
            status: false,
            logoutDisplay: true,
            userFace: '',
            countryCode: '',
            showHeader: false,
            islogined: false,
            closeState: true,
            scrollY: 0
        };
    },
    components: {
        rightMenu,
        loginReg
    },
    computed: {
        leaveTop() {
            return this.scrollY > 0;
        },
        /**
         * 获取当前的状态 默认是home
         */
        getCurrentStatus() {
            const defauleClass = ['home', 'explore', 'personal'];
            const hrefStr = window.location.href || '';
            // eslint-disable-next-line no-plusplus
            for (let i = 0, l = defauleClass.length; i < l; i++) {
                // eslint-disable-next-line no-useless-escape
                const re = new RegExp(`\/${defauleClass[i]}.html`);
                if (hrefStr.match(re)) {
                    return defauleClass[i];
                }
            }
            return 'home'; // default value
        }
    },
    methods: {
        KEWLSensorTrack(pathname) {
            util.KEWLSensorTrack({ lmweb_clickText: '跳转', lmweb_tabName: pathname });
        },
        /**
         * 展示推出登陆
         */
        showLogout() {
            this.logoutDisplay = false;
        },
        hideLogout() {
            this.logoutDisplay = true;
        },
        /**
         * 退出登陆
         */
        logoutAction() {
            this.$refs.logReg.logoutAction();
            this.userInfo = null;
            this.islogined = false;
            this.logoutDisplay = true;
        },
        /**
         * 弹出登陆层
         */
        doLogin() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            this.$refs.logReg.showFrame();
            util.KEWLSensorTrack({ lmweb_clickText: '唤起登陆' });
        },
        /**
         * 弹出登陆层
         */
        doReg() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            this.$refs.logReg.showFrame();
            util.KEWLSensorTrack({ lmweb_clickText: '唤起登陆' });
        },
        /**
         * 获取当前用户的头像
         */
        getLoginUserFace() {
            if (webLogin.checkLogin()) {
                const backgroundUrl = webLogin.getUserInfo().face;
                this.userFace = `background-image:url(${backgroundUrl})`;
            }
        },
        /**
         * 切换其他菜单
         */
        changeMenu(state) {
            this.closeState = state;
        },
        // 带参传递
        getHeaderLink(pathname) {
            let local = util.getI18nLocale();
            local = pathname == '/' ? '' : local;
            // 带参传递
            const json = {
                pathname: `/${local}${pathname == '/' ? '' : pathname}`,
                search: {}
            };
            return util.directToPath(json, true);
        },
        /**
         * 跳转 其他页面
         */
        doRecharge() {
            webRecharge.doRecharge();
        },
        /**
         * 跳转 其他页面
         */
        doConvert() {
            webConvertAndCash.doConvert();
        },
        /**
         * 跳转 其他页面
         */
        doCashOut() {
            webConvertAndCash.doCashOut();
        },
        /**
         * 推出登陆
         */
        logoutHandle() {
            this.userInfo = null;
            this.islogined = false;
            this.$lmBus && this.$lmBus.$emit('Live-Login-Out-Handle');
        },
        /**
         * 登陆成功
         */
        successHandle(data) {
            this.userInfo = data;
            this.islogined = true;
            this.$refs.logReg.closeFrame();
            this.getLoginUserFace();
            this.$lmBus && this.$lmBus.$emit('Live-Login-Success-Handle', data);
        }
    },
    created() {
        this.$lmBus && this.$lmBus.$on('Header-Login-Success-Handle', (data) => {
            if (data) {
                this.userInfo = data;
                this.islogined = true;
                this.getLoginUserFace();
            }
        });
        this.$lmBus && this.$lmBus.$on('Header-Login-Out-Handle', () => {
            this.userInfo = null;
            this.islogined = false;
        });
        this.$lmBus && this.$lmBus.$on('Header-Login-Pop-Handle', (type) => {
            if (type === 'login') {
                this.doLogin();
            } else {
                this.doReg();
            }
        });
    },
    beforeMount() {
        const self = this;
        window && window.addEventListener('scroll', () => {
            self.scrollY = window.scrollY;
        });
    },
    async mounted() {
        this.showHeader = true;
        this.countryCode = await util.getI18nCountryCode(this.$route && this.$route.params.countryCode);
        this.islogined = webLogin.checkLogin();
        this.userInfo = webLogin.getUserInfo();
        this.getLoginUserFace();
        /**
         * 当然国家码是台湾并且来源是姐妹淘，  就展示姐妹淘logo
         */
        if (util.isJMT(this.countryCode)) {
            this.isJmt = true;
        }
    }
};
</script>
<style lang="less" scoped>
@import url('../../../biz/css/_grid');

.header {
    .top {
        height: 60px;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background: #fff;
        z-index: 9999;
        transition: all .5s;
        &.topbar-scroll-bg {
            background: #fff;
            height: 60px;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 100;
            box-shadow: 0 2px 10px 0 rgba(0,0,0,0.20);
            .top {
                background: #fff;
            }
        }
        .logo {
            display: inline-block;
            float: left;
            width: 145px;
            height: 36px;
            background: url('./images/logo.png') no-repeat center center transparent;
            background-size: contain;
            margin: 12px 30px;
        }
        .nav {
            display: inline-block;
            float: left;
            margin-left: 40px;
            height: 100%;
            line-height: 100%;
            .link {
                display: inline-block;
                color: #333;
                height: 100%;
                line-height: 60px;
                position: relative;
                text-align: center;
                font-size: 20px;
                padding: 0 15px;
                margin-right: 20px;
                &.current:after {
                    content: '';
                    position: absolute;
                    width: 100%;
                    bottom: 0px;
                    border-bottom: 4px solid #00fdff;
                    left: 0;
                    color: #00fdff;
                }
            }
        }
        .action {
            margin-right: 30px;
            display: inline-block;
            position: relative;
            float: right;
            right: 0;
            top:0;
            height: 60px;
            //  完善css，之前提交的没有更新上去，重新提交一次
            .download {
                display: inline-block;
                height: 100%;
                line-height: 60px;
                position: relative;
                font-size: 14px;
                margin-right: 30px;
                color: #ffde00;
                &:before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                }
            }
            .download {
                padding-left: 30px;
                cursor: pointer;
                .dfont {
                    color: #fff;
                }
                &:before {
                    margin-top: -11px;
                    width: 14px;
                    height: 23px;
                }
                &:hover .top_download {
                    display: block;
                }
                &:hover .dfont {
                    opacity: 0.6;
                }
            }
            .recharge_wrap {
                display: inline-block;
                height: 100%;
                line-height: 60px;
                position: relative;
                font-size: 14px;
                color: #333;
                cursor: pointer;
                &:before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                }
                &:hover {
                    opacity: 1;
                    .recharge_txt {
                        opacity: .6;
                    }
                }

                .recharge_list {
                    position: absolute;
                    top: 64px;
                    padding: 0 5px;
                    background: #fff;
                    border-radius: 8px;
                    border-top-left-radius: 0;
                    border-top-right-radius: 0;
                    border-top: 4px solid #00fdff;
                    border-left: 1px solid #eeeeee;
                    border-right: 1px solid #eeeeee;
                    border-bottom: 1px solid #eeeeee;
                    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.35);
                    left: 50%;
                    margin-left: -95px;
                    z-index: 200;
                    cursor: pointer;
                    display: none;
                    &:before {
                        content: '';
                        display: block;
                        border: 7px solid transparent;
                        border-bottom-color: #00fdff;
                        width: 0;
                        height: 0;
                        position: absolute;
                        left: 50%;
                        top: -18px;
                        margin-left: -3px;
                    }
                    a {
                        display: block;
                        width: 165px;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        font-size: 16px;
                        color: #666;
                        border-bottom: 1px solid #ddd;
                        &:last-child {
                            border-bottom: none;
                        }
                        &:hover {
                            opacity: .6;
                        }
                    }
                }
                &:hover .recharge_list {
                    display: block;
                }
            }
            .logwrap_login{
                padding: 0 10px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                border: 1px solid #9D1DFF;
                font-size: 14px;
                color: #9D1DFF!important;
                border-radius: 15px;
            }
            .logwrap{
                display: inline-block; color: #333;font-size: 16px;
                a {
                    display: inline-block;
                    color: #333;
                    // padding: 0 8px;
                    text-align: center;
                }
            }
            .explore {
                display: block;
            }
            .right-header{
                display: inline-block;
                color: #333;
                font-size: 16px;
                float: right;
                line-height: 60px;
                margin-left: 30px;
                a{
                    color: #333;
                }
                &.menu{
                    position: relative;
                    width: 16px;
                    height: 12px;
                    top: 24px;
                    background: url('./images/menu.png') no-repeat center center transparent;
                    background-size: contain;
                }
            }
            .login_info {
                position: relative;
                // margin-top: 15px;
                .face {
                    position: relative;
                    vertical-align: middle;
                    display: inline-block;
                    height: 32px;
                    width: 32px;
                    background-color: #333;
                    border-radius: 100%;
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: center;
                }
                .nickname {
                    display: none;
                    // height: 32px;
                    max-width: 100px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 16px;
                    // line-height: 32px;
                    vertical-align: bottom;
                    color: #333;
                    padding-left: 10px;
                    padding-right: 30px;
                    position: relative;
                    &:after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        margin-top: -3px;
                        right: 0;
                        height: 0;
                        width: 0;
                        border-top: 6px solid #333;
                        border-right: 6px solid transparent;
                        border-left: 6px solid transparent;
                    }
                }
                .logout {
                    height: 40px;
                    width: 110px;
                    background-color: #fff;
                    border-radius: 5px;
                    text-align: center;
                    line-height: 40px;
                    color: #333;
                    font-size: 18px;
                    position: absolute;
                    right: -36px;
                    top: 58px;
                    border: 1px solid #eeeeee;
                    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.35);
                    cursor:pointer;
                    &:after {
                        content: '';
                        position: absolute;
                        top: -12px;
                        left: 50%;
                        margin-left: -6px;
                        height: 0;
                        width: 0;
                        border-bottom: 12px solid #fff;
                        border-right: 10px solid transparent;
                        border-left: 10px solid transparent;
                    }
                }
            }
            .top_download {
                width: 195px;
                height: 330px;
                background: #fff;
                position: absolute;
                top: 64px;
                border-radius: 8px;
                border-top-left-radius: 0;
                border-top-right-radius: 0;
                border-top: 4px solid #00fdff;
                box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.35);
                left: -20px;
                z-index: 200;
                display: none;
                &:before {
                    content: '';
                    display: block;
                    border: 7px solid transparent;
                    border-bottom-color: #00fdff;
                    width: 0;
                    height: 0;
                    position: absolute;
                    left: 50%;
                    top: -18px;
                    margin-left: -3px;
                }
            }
            .wr-btn{
                position: relative;
                display: inline-block;
                width: 120px;
                height: 38px;
                background: #FF42FF;
                color: #fff;
                border-radius: 19px;
                line-height: 38px;
                text-align: center;
                overflow: hidden;
                transform: rotate(0deg);
                cursor: pointer;
                vertical-align: middle;
                margin-left: 15px;
                background-image: url(./images/open_icon.png);
                background-repeat: no-repeat;
                background-size: 24px 21px;
                background-position: 28px 9px;
                top: 10px;
            }
            .wr-btn span{
                position: relative;
                display: block;
                height: 100%;
                width: 100%;
                left: 16px;
            }
            .wr-btn:after{
                content: '';
                display: inline-block;
                position: relative;
                height: 100px;
                width: 12px;
                background: #fff;
                opacity: 0.3;
                transform: rotateZ(-30deg) translate(-25px,-60px);
                animation: move 2s linear infinite;
            }

            @keyframes move
            {
                from { transform: rotateZ(-30deg) translate(-25px,-60px); }
                to { transform: rotateZ(-30deg) translate(93px,-60px); }
            }
        }
    }
    .toprelative{position: relative; top: 0; left: 0; z-index: 0;}
}
.homeheader{
    position: relative;
    top: 0;
    left: 0;
    .header{
        .top{
            .container{padding: 0 20px; position: absolute;}
            .logo{
                display: inline-block;
                float: left;
                width: 145px;
                height: 36px;
                background-size: contain;
                margin: 12px 30px;
            }
            .logo-jmt{
                display: inline-block;
                float: left;
                width: 89px;
                height: 33px;
                margin: 12px 20px;
                background: url(./images/logo-jmt.png) no-repeat 50% transparent;
                background-size: 100% 100%;
            }
        }
    }
}

@media (max-width: @mobile) {
    .homeheader, .list{
        .header {
            // background-color: #402087;
            .right-menu{
                position: fixed;
                width: 100%;
                height: 100%;
                background: #fff;
                z-index: 9999;
                top: 0;
                right: 0;
                left: 0;
                padding: 60/75rem 20/75rem;
                .close {
                    position: fixed;
                    top: 10/75rem;
                    right: 10/75rem;
                    width: 24/75rem;
                    height: 24/75rem;
                    // background: #000;
                    &.closeani{

                    }
                }
                .main-title-container{
                    width: 50%;
                    color: #000;
                    float: left;
                    clear: both;
                    box-sizing: border-box;
                    font-size: 60/75rem;
                    color: #000000;
                    letter-spacing: 0;
                    cursor: pointer;
                    // font-weight: 700;
                    li{
                        display: inline-block;
                        line-height: 72/75rem;
                        margin-bottom: 30/75rem;
                        &.current{
                            span {
                                position: relative;
                                float: left;
                                clear: both;
                            }
                            span::after {
                                content: '';
                                position: absolute;
                                width: 100%;
                                height: 20/75rem;
                                opacity: 0.6;
                                left: 0;
                                bottom: 0;
                                background: #FF42FF;
                            }
                        }
                    }
                }
                .sub-title-container{
                    margin-top: 40/75rem;
                    width: 50%;
                    color: #000;
                    float: left;
                    box-sizing: border-box;
                    font-size: 28/75rem;
                    color: #000000;
                    letter-spacing: 0;
                    float: left;
                    clear: both;
                    &.right-state{
                        display: none;
                    }
                    &.bottom-state{
                        display: block;
                    }
                    li {
                        display: block;
                        height: 34/75rem;
                        line-height: 34/75rem;
                        margin-bottom: 25/75rem;
                        margin-left:  0px;
                    }
                }
                .popular{
                    display: block;
                    float: left;
                    width: 100%;
                    border-top: 1px solid rgba(0,0,0,.12);
                    li {
                        color: #333;
                        line-height: 80/75rem;
                        font-size: 28/75rem;
                    }
                }
                .bottomlogo{
                    position: absolute;
                    text-align: center;
                    left: 0;
                    bottom: 50/75rem;
                    width: 100%;
                    height: 30/75rem;
                    a{
                        display: inline-block;
                        text-align: center;
                        width: 30/75rem;
                        height: 30/75rem;
                        border-radius: 50%;
                        margin: 0 20/75rem;
                    }
                }
            }
            .top {
                height: 0.8rem;
                .container{max-width: auto; min-width: auto; padding:0;}
                .nav {
                    display: none;
                }
                &.topbar-scroll-bg{
                    height: .8rem;
                }
                .logo {
                    width: 145/75rem;
                    height: 36/75rem;
                    background-repeat: no-repeat;
                    background-position: center transparent;
                    background-size: contain;
                    margin: 12/75rem 15/75rem;
                }
                .action {
                    // margin-right: 0.2rem;

                    margin-right: 15/75rem;
                    display: inline-block;
                    position: absolute;
                    float: right;
                    right: 0;
                    top:0;
                    // width: 375px;
                    height: 60/75rem;

                    .download {
                        display: none;
                    }
                    .right-header{
                        display: inline-block;
                        color: #333;
                        font-size: 16/75rem;
                        float: right;
                        // height: 60px;
                        line-height: 60/75rem;
                        margin-left: 30/75rem;
                        white-space: nowrap;
                        a{
                            color: #333;
                        }
                        &.menu{
                            position: relative;
                            width: 22.5/75rem;
                            height: 18.75/75rem;
                            top: 19.5/75rem;
                            background: url('./images/menu.png') no-repeat center center transparent;
                            // background-size: auto 45px;
                            background-size: contain;
                        }
                    }

                    .explore {
                        display: none;
                    }
                    .recharge_wrap {
                        line-height: 0.8rem;
                        font-size: 16/75rem;
                        // margin-right: .3rem;
                        &:before {
                            content: '';
                            position: absolute;
                            left: 0;
                            top: 50%;
                        }
                        &:hover {
                            opacity: 1;
                            .recharge_txt {
                                opacity: .6;
                            }
                        }
                        &:hover .recharge_list {
                            display: block;
                        }
                        .recharge_list {
                            top: 0.8rem;
                            padding: 0 .05rem;
                            border-radius: .08rem;
                            border-top: .04rem solid #00fdff;
                            margin-left: -1.9rem;
                            display: none;
                            &:before {
                                content: '';
                                display: block;
                                border: .14rem solid transparent;
                                border-bottom-color: #00fdff;
                                width: 0;
                                height: 0;
                                position: absolute;
                                left: 50%;
                                top: -.32rem;
                                margin-left: -.06rem;
                            }
                            a {
                                display: block;
                                width: 3.3rem;
                                height: 1rem;
                                line-height: 1rem;
                                text-align: center;
                                font-size: .3rem;
                            }
                        }
                    }
                    .logwrap_login{
                        // display: block;
                        // width: 90/75rem;
                        padding: 0 10/75rem;
                        height: 30/75rem;
                        line-height: 30/75rem;
                        text-align: center;
                        border: 1px solid #9D1DFF;
                        font-size: 14/75rem;
                        color: #9D1DFF !important;
                        border-radius: 15/75rem;
                    }
                    .login_info {
                        margin-right: 0;
                        margin-top: 0;
                        .face {
                            width: .58rem;
                            height: .58rem;
                            margin-top: -0.1rem;
                        }
                        .nickname {
                            display: none;
                        }
                        .logout {
                            height: .5rem;
                            width: 1.4rem;
                            border-radius: .1rem;
                            text-align: center;
                            line-height: .5rem;
                            color: #333;
                            font-size: .24rem;
                            position: absolute;
                            right: -0.36rem;
                            top: 0.78rem;
                            &:after {
                                content: '';
                                position: absolute;
                                top: -.12rem;
                                left: 50%;
                                margin-left: -.06rem;
                                height: 0;
                                width: 0;
                                border-bottom: .12rem solid #fff;
                                border-right: .1rem solid transparent;
                                border-left: .1rem solid transparent;
                            }
                        }
                    }
                }
            }
        }
    }
    .header {
        // background-color: #402087;
        .top {
            height: 0.8rem;
            .container{max-width: auto; min-width: auto; padding:0;}
            .nav {
                display: none;
            }
            &.topbar-scroll-bg{
                height: .8rem;
            }
            .logo {
                width: 1.225rem;
                height: .45rem;
                background-repeat: no-repeat;
                background-position: center transparent;
                background-size: contain;
                margin-left: .2rem;
                margin-top: .2rem;
            }
            .action {
                .download {
                    display: none;
                }
                .recharge_wrap {
                    line-height: 0.8rem;
                    font-size: .26rem;;
                    // margin-right: .5rem;
                    &:before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 50%;
                    }
                    &:hover {
                        opacity: 1;
                        .recharge_txt {
                            opacity: .6;
                        }
                    }
                    &:hover .recharge_list {
                        display: block;
                    }
                    .recharge_list {
                        top: 0.8rem;
                        padding: 0 .05rem;
                        border-radius: .08rem;
                        border-top: .04rem solid #00fdff;
                        margin-left: -1.9rem;
                        display: none;
                        &:before {
                            content: '';
                            display: block;
                            border: .14rem solid transparent;
                            border-bottom-color: #00fdff;
                            width: 0;
                            height: 0;
                            position: absolute;
                            left: 50%;
                            top: -.32rem;
                            margin-left: -.06rem;
                        }
                        a {
                            display: block;
                            width: 3.3rem;
                            height: 1rem;
                            line-height: 1rem;
                            text-align: center;
                            font-size: .3rem;
                        }
                    }
                }
                .login_info {
                    margin-right: 0;
                    margin-top: 0;
                    .face {
                        width: .58rem;
                        height: .58rem;
                        margin-top: .15rem;
                    }
                    .nickname {
                        display: none;
                    }
                    .logout {
                        height: .5rem;
                        width: 1.4rem;
                        border-radius: .1rem;
                        text-align: center;
                        line-height: .5rem;
                        color: #333;
                        font-size: .24rem;
                        position: absolute;
                        right: -.3rem;
                        &:after {
                            content: '';
                            position: absolute;
                            top: -.12rem;
                            left: 50%;
                            margin-left: -.06rem;
                            height: 0;
                            width: 0;
                            border-bottom: .12rem solid #fff;
                            border-right: .1rem solid transparent;
                            border-left: .1rem solid transparent;
                        }
                    }
                }
                .searchglobal{display: none}
                .wr-btn{display: none!important;}
            }
        }
        .banner {
            height: 2.45rem;
            background: url(/assets/images/m_banner2.jpg) no-repeat center transparent;
            background-size: cover;
        }
    }
}
</style>
